import React from "react"
import styled from 'styled-components'
import Loading from './Loading'
import { useTransition, animated as a, config } from 'react-spring'

const AnimatedPage = styled(a.div)`
  will-change: opacity;
`

const LoadingTransition = ({ children, isLoading }) => {

  const transition = useTransition(isLoading, null, {
    config: config.slow,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { 
      position: 'absolute',
      top: '50%',
      left: '50%',
      opacity: 0
    },
  })

  return (
    <>
      {transition.map(({ item, key, props }) => {
        return (
          <AnimatedPage key={key} style={props}>
            {item ? <Loading /> : children}
          </AnimatedPage>
        )
      })}
    </>
  )
}

export default LoadingTransition